module.exports = __webpack_public_path__ + "img/release_risk_bg4.3d821032.jpg";